/** Company slugs for the Companies page addresses. Pure, so the directory builder can run anywhere. */
import { slugifySegment } from '../../../utils/slug';

export const INDIVIDUALS_SLUG = 'individuals';

/** Employer slugs stay the plain name slug, so /employers/<slug> redirects land on the same segment. */
export const employerCompanySlug = (name: string) => slugifySegment(name);

/** A client whose name matches an employer's gets a "-client" suffix so the two addresses differ. */
export function clientCompanySlug(name: string, employerNames: readonly string[]): string {
  const slug = slugifySegment(name);
  return employerNames.some(employer => slugifySegment(employer) === slug) ? `${slug}-client` : slug;
}
